import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@schuettflix/react-components';
import { PlusIcon } from '@schuettflix/icons-react';
import { GeoAddressPanel } from '@/modules/location/components/geoaddress/GeoAddressPanel.tsx';
import { GeoAddress } from '@/modules/location/domain/GeoAddressSchema.ts';

type GeoAddressSectionProps = {
    onSubmit: (contact: GeoAddress) => void;
    disabled?: boolean;
};

export const GeoAddressSection = (props: GeoAddressSectionProps) => {
    const { t } = useTranslation();
    const [showPanel, setShowPanel] = useState(false);

    return (
        <div>
            <Link
                tabIndex={0}
                prefix={<PlusIcon size="xs" />}
                className="font-copy-md-strong pt-1"
                label={t('location.newAddress.link')}
                onClick={() => setShowPanel(true)}
                onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setShowPanel(true);
                    }
                }}
                disabled={props.disabled}
            />

            {showPanel && (
                <GeoAddressPanel
                    onClose={() => {
                        setShowPanel(false);
                    }}
                    onSubmit={value => {
                        setShowPanel(false);
                        props.onSubmit(value);
                    }}
                ></GeoAddressPanel>
            )}
        </div>
    );
};
